import { render, staticRenderFns } from "./modify.vue?vue&type=template&id=2dc93b0c&scoped=true"
import script from "./modify.vue?vue&type=script&setup=true&lang=js"
export * from "./modify.vue?vue&type=script&setup=true&lang=js"
import style0 from "./modify.vue?vue&type=style&index=0&id=2dc93b0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc93b0c",
  null
  
)

export default component.exports